import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../Redux/slices/authSlice";
import { CapitalizeName } from "../../../utils/capitalizeName";
import { IconButton, Typography, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "../assets/images/logoAi.png";
import "../assets/css/main.css";

const Header = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userName = CapitalizeName(user?.name || "");

  const isInterviewPage =
    location.pathname === "/interview/question" ||
    location.pathname === "/interview/finish";

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        document.body.classList.add("scrolled");
      } else {
        document.body.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(logout());
    navigate("/");
  };

  return (
    <header id="header" className="header fixed-top">
      <a
        className="logo_and_title"
        href="/"
        onClick={(e) => {
          e.preventDefault();
          navigate("/");
        }}
      >
        <img src={logo} alt="Logo" />
      </a>

      <nav id="navmenu" className="navmenu">
        <ul>
          <li>
            <a href="/" className="active">
              Home
            </a>
          </li>
          <li>
            <a href="/about">About</a>
          </li>
          <li>
            <a href="#pricing">Pricing</a>
          </li>
        </ul>
        <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
      </nav>

      {!isAuthenticated && (
        <div className="header-actions" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <a className="btn-getstarted" href="/login">
            Login
          </a>
          <a
            className="btn-getstarted"
            href="/interviewerjoining"
            onClick={(e) => {
              e.preventDefault();
              navigate("/interviewerjoining");
            }}
          >
            Join as interviewer
          </a>
        </div>
      )}

      {isAuthenticated && (
        <div className="auth-user">
          <Typography>Welcome, {userName}</Typography>

          {!isInterviewPage && (
            <Tooltip title="Logout" arrow>
              <span>
                <IconButton className="logout-btn" onClick={handleLogOut}>
                  <LogoutIcon className="logout-icon" />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;